<template>
  <div
    class="search column"
    @keyup.up="changeActive(--active)"
    @keyup.down="changeActive(++active)"
  >
    <div class="row align-center">
      <input
        type="text"
        class="input"
        v-model="data.search"
        :placeholder="data.placeholder"
        @keyup.enter="data.action"
        @click="data.autocomplete ? (data.autocomplete.list = []) : false"
      />

      <Loader layout="mini" v-if="data.loader" />
      <i v-else class="fa-solid fa-magnifying-glass" @click="data.action" />
    </div>

    <ul
      v-if="data.autocomplete && data.autocomplete.list && data.autocomplete.list.length"
    >
      <li
        v-for="(item, i) in data.autocomplete.list"
        :key="i + '-complete'"
        :class="active == i && 'active'"
        @click="
          data.autocomplete.choice(item);
          data.autocomplete.list = [];
        "
        @keyup.enter="
          data.autocomplete.choice(item);
          data.autocomplete.list = [];
        "
        :tabIndex="i"
        :id="'complete' + i"
      >
        {{ item[data.autocomplete.name] }}
      </li>
    </ul>
  </div>
</template>

<script>
import Loader from "@/components/Loader.vue";
export default {
  name: "Search",
  components: { Loader },
  props: ["data"],
  data() {
    return { active: 0 };
  },
  methods: {
    changeActive() {
      if (this.active == -1) this.active = 0;
      if (
        this.active == this.data.autocomplete.length &&
        this.data.autocomplete.length != 1
      )
        this.active--;
      if (
        this.active == this.data.autocomplete.length &&
        this.data.autocomplete.length == 1
      )
        this.active = 0;
      let select = document.getElementById("complete" + this.active);
      if (select) {
        select.blur();
        select.focus();
      }
    },
  },
  mounted() {
    let select = document.getElementById("complete" + this.active);
    if (select) {
      select.blur();
      select.focus();
    }
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.search
  i, .loader
    margin-left: -32px
  ul
    padding-top: 12px
    margin-top: 21px
    background: white
    border-radius: 19px
    overflow: hidden
    max-height: 190px
    overflow-y: auto
    @include border
    @media (max-width: $small)
      width: 90%
      margin:60px 5%

    li
      padding: 12px
      font-size: 14px
      &:hover, &.active
        background: $supporter-1
        opacity: .8
        color: white
        cursor: pointer
        border-radius: 19px
      &:focus
        outline: none
</style>
